export default {
  baseUrl: 'https://www.baigang.com/',
  // baseUrl: 'http://192.168.241.1/',
  userCenterHostUrl: 'https://www.baigang.com/uc/',
  gongyingHostUrl: 'https://www.baigang.com/gy/',
  searchHostUrl: 'https://www.baigang.com/',
  bgSearchHostUrl: 'https://www.baigang.cn/'
}



// WEBPACK FOOTER //
// ./src/assets/js/pubilshSet.js